import 'swiper/dist/css/swiper.css';

import { swiper, swiperSlide } from 'vue-awesome-swiper';
import messages from './items-slider-translations';
import { SharedService } from '../../../shared/services/sharedService';
import thumbnailmapList from '../../../shared/components/thumbnailmap-list/thumbnailmap-list.vue';

export default {
    name: 'itemsSlider',
    i18n: {
        messages,
    },
    data() {
        return {
            swiperOption: {
                notNextTick: true,
                autoplay: 0,
                slidesPerView: (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 768) ? 1 : 2,
                autoplayDisableOnInteraction: false,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                paginationClickable: true,
                observeParents: true,
            },
        };
    },
    components: {
        swiper,
        swiperSlide,
        thumbnailmapList,
    },
    filters: {
        dateFormat: (value) => SharedService.dateFormat(value),
        dateDay: (value) => SharedService.dateDay(value),
        dateMonth: (value, lang) => SharedService.dateMonth(value, lang),
        dateYear: (value) => SharedService.dateYear(value),
        truncate: (value, length) => SharedService.truncateText(value, length),
    },
    props: {
        selectedLang: { type: String },
        homePreviewMaps: { type: Array },
    },
};



// WEBPACK FOOTER //
// ./src/home/components/items-slider/items-slider.js